
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/pecas",
      function () {
        return require("private-next-pages/pecas/index.tsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/pecas"])
      });
    }
  